import type { AdminOrderBy, AdminSortBy } from '../types';

export const ADMIN_SEARCH_BASE_URL = '/admin/search';

export const ALGOLIA_SEARCH_DEBOUNCE_MS = 300;

export enum AdminSearchParamOptions {
  QUERY = 'query',
  TYPES = 'types',
  CONTENT_SOURCES = 'contentSources',
  TAGS = 'tags',
  SKILLS = 'skills',
  UPDATED_DATE = 'updatedDate',
  UPDATED_BY = 'updatedBy',
  SORT_BY = 'sortBy',
  SORT_ORDER = 'sortOrder',
}

export enum AdminSearchContentTypes {
  GUIDE = 'guide',
  PATH = 'path',
  LIBRARY = 'library',
  RESOURCE = 'resource',
  CHALLENGE = 'challenge',
  SCORM = 'scorm',
  EVENT = 'event',
  CONTENT_PROVIDER_CONTENT = 'content_provider_content',
  ITEM_FOLDER = 'item_folder',
}

export enum GuideSubTypes {
  SECTION = 'guide_section',
  TASK = 'guide_task',
}

export enum AdminSearchContentSources {
  LINKEDIN_LEARNING = 'linkedin_learning',
  UDEMY = 'udemy',
}

export enum AdminSortByOptions {
  RECENT = 'recent',
  RELEVANCE = 'relevance',
}

export enum AdminOrderByOptions {
  ASC = 'asc',
  DESC = 'desc',
}

export const DEFAULT_ADMIN_SORT_BY: AdminSortBy = 'relevance';
export const DEFAULT_ADMIN_SORT_ORDER: AdminOrderBy = 'desc';
export const ADMIN_SORT_KEYS: AdminSortBy[] = ['recent', 'relevance'];
export const ADMIN_ORDER_KEYS: AdminOrderBy[] = ['asc', 'desc'];

export const TAG_LIMIT = 100;
export const SKILL_LIMIT = 100;

export enum AdminSearchUpdateDate {
  LAST_7_DAYS = 'last_7_days',
  LAST_30_DAYS = 'last_30_days',
  LAST_YEAR = 'last_year',
  ALL_TIME = 'all_time',
}
